import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Modal,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import { MdDelete, MdModeEdit, MdPersonOff } from "react-icons/md"
import { useContext, useEffect, useState } from "react"
import { DataFilter, ItemsPerPage } from "components/Common/filters"
import { useSelector, useDispatch } from "react-redux"
import { allStaffs, StaffDelete, StaffFetch } from "redux/slice/staff/staffSlice"
import PaginationComponent from "components/Common/pagination"
import Loader from "components/Common/loader"
import SidebarContext from "context/sidebar.context"
import { getUserTokenEmail } from "utilities/parse-jwt"
import Notify from "components/Common/notify"
import { SHUK_AUTH_PORTAL_TOKEN, SHUK_ROLE_VIWEWER } from "redux/enums"
import { useNavigate } from "react-router-dom"
import { userData } from "redux/slice/user/userSlice"

export default function StaffTable(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { userRole } = useSelector(userData) 
  const { staffMembersData, loading, totalPages } = useSelector(allStaffs)
  const { currentPage, setCurrentPage, itemsPerPage, setItemsPerPage, filters, setFilters } = useContext(SidebarContext)
  const [deleteIdState, setDeleteIdState] = useState(null)
  const [deleteModalState, setDeleteModalState] = useState(false)

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  const paginate = pageNumber => {
    console.log("paginate call with page number: ", pageNumber)
    setCurrentPage(pageNumber)
    let data = {
      pageNumber: pageNumber,
      pageSize: itemsPerPage,
      ...(filters.isDelete !== '' && { IsDelete: filters.isDelete === 'true' }),
      Role: filters.role ? filters.role : null
    };
    dispatch(StaffFetch(data))
  }

  useEffect(() => {
    let data = {
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      ...(filters.isDelete !== '' && { IsDelete: filters.isDelete === 'true' }),
      Role: filters.role ? filters.role : null
    };
    dispatch(StaffFetch(data))
  }, [itemsPerPage, filters])

  const handleItemsPerPage = (perPage) => {
    console.log("perPage", perPage);
    if(perPage !== itemsPerPage){
      setCurrentPage(1)
    }
    setItemsPerPage(Number(perPage));
  }

  const handleUpdate = received => {
    console.log("update", received.id)
    props.forUpdate(received)
  }

  const handleDelete = async() => {
    console.log("deleteIdState", deleteIdState)
    let loginUserEmail = await getUserTokenEmail()
    dispatch(StaffDelete(deleteIdState?.id))
    .then((staff_del_resp)=>{
      console.log("staff_del_resp", staff_del_resp)
      console.log("loginUserEmail", loginUserEmail)
      if(deleteIdState?.email && loginUserEmail && deleteIdState.email === loginUserEmail){
        localStorage.removeItem(SHUK_AUTH_PORTAL_TOKEN)
        Notify("error", "This user is deleted. Login again")
        navigate("/login");
      }
    })
    .catch((err)=>{
      console.log(err)
    })
    setDeleteModalState(false);
  }

  console.log("userRole from Redux:", userRole)

  return (
    <div className="staff-table-container">
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 dot-after ms-3">Staff</CardTitle>
            <CardBody>
              <div className="d-flex justify-content-end flex-row align-items-center" style={{width: "100%"}}>
                <div className="me-3">
                  <DataFilter
                    options={[
                      { id: "", name: "All" },
                      { id: "Admin", name: "Admin" },
                      { id: "Review Committee", name: "Review Committee" },
                      { id: "Board Member", name: "Board Member" },
                      { id: "Viewer", name: "Viewer" },
                    ]}
                    value={filters.role}
                    label="User Type"
                    onChange={e => {
                      setFilters(prev => ({
                        ...prev,
                        role: e.target.value,
                      }))
                    }}
                  />
                </div>
                <div className="me-3">
                  <DataFilter
                    options={[
                      { id: "true", name: "Disabled" },
                      { id: "false", name: "Existing" },
                    ]}
                    value={filters.isDelete}
                    label="User Status"
                    onChange={e => {
                      setFilters(prev => ({
                        ...prev,
                        isDelete: e.target.value,
                      }))
                    }}
                  />
                </div>
                <div>
                  <ItemsPerPage
                    value={itemsPerPage}
                    handleItemsPerPage={handleItemsPerPage}
                  />
                </div>
              </div>

              <div className="app-table-body">
                {loading ? (
                  <Loader />
                ) : (
                  <Table className="table mb-0 table-bordered">
                    <thead>
                      <tr>
                        <th className="text-nowrap">First Name</th>
                        <th className="text-nowrap">Last Name</th>
                        <th className="text-nowrap">Email</th>
                        <th className="text-nowrap">Phone</th>
                        <th className="text-nowrap">User Type</th>
                        {!isViewer && (
                          <th className="text-nowrap">Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {staffMembersData ?.filter(staff => {
                        if (filters?.isDelete === "false") {
                          return !staff?.isDelete;
                        }
                        if (filters?.isDelete === "true") {
                          return staff?.isDelete === true;
                        }
                        return true;
                      }).map((staff, index) => (
                        <tr key={staff?.id} style={ staff?.isDelete == true ? {backgroundColor: '#fff7f7'} : null }>
                          <td className="text-nowrap" style={{ backgroundColor: 'inherit' }}>{staff?.firstName}</td>
                          <td className="text-nowrap" style={{ backgroundColor: 'inherit' }}>{staff?.lastName}</td>
                          <td className="text-nowrap" style={{ backgroundColor: 'inherit' }}>{staff?.email}</td>
                          <td className="text-nowrap" style={{ backgroundColor: 'inherit' }}>{staff?.phoneNumber}</td>
                          <td className="text-nowrap" style={{ backgroundColor: 'inherit' }}>
                            {staff?.roles?.length > 0 ? staff?.roles[0] : ""}
                          </td>
                          {!isViewer && (
                            <td className="d-flex" style={{ backgroundColor: 'inherit' }}>
                              {  
                              
                              staff?.isDelete == false ?
                              <>
                                <span
                                  id={`edit-staff-${staff?.id}`}
                                  className="me-2"
                                  style={{ cursor: "pointer" }}
                                >
                                  <MdModeEdit
                                    className="text-primary"
                                    onClick={() => handleUpdate(staff)}
                                    size={18}
                                  />
                                </span>
                                <UncontrolledTooltip
                                  placement="top"
                                  className="black-tooltip"
                                  target={`edit-staff-${staff?.id}`}
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <span
                                  id={`disable-staff-${staff?.id}`}
                                  style={{ cursor: "pointer" }}
                                >
                                  <MdPersonOff
                                    className="text-danger"
                                    onClick={() => {
                                      setDeleteIdState(staff)
                                      setDeleteModalState(true)
                                    }}
                                    size={18}
                                  />
                                </span>
                                <UncontrolledTooltip
                                  placement="top"
                                  className="black-tooltip"
                                  target={`disable-staff-${staff?.id}`}
                                >
                                  Disable
                                </UncontrolledTooltip>
                              </> : <span className="badge bg-danger">Disabled</span>
                              }
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-center justify-content-md-end justify-content-lg-end align-items-center flex-wrap">
                <div style={{ marginLeft: "4px" }}>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    paginate={paginate}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={deleteModalState} centered>
        <Card className="bg-white">
          <CardBody className="mt-2">
            <h5 style={{ fontWeight: "normal" }}>
              Are You Sure. You want to disable this staff?
            </h5>
          </CardBody>
          <CardFooter>
            <div className="mt-4 float-end">
              <button
                className="btn btn-danger me-2"
                onClick={() => handleDelete()}
              >
                Yes
              </button>
              <button
                className="btn btn-primary"
                onClick={() => setDeleteModalState(false)}
              >
                No
              </button>
            </div>
          </CardFooter>
        </Card>
      </Modal>
    </div>
  )
}